!function(){
  "use strict";

  class t extends window.theme.DeferredMedia {
    constructor() {
      super();
    }

    loadContent() {
      super.loadContent();
      Shopify.loadFeatures([{
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this)
      }]);
    }

    setupModelViewerUI(t) {
      t || (this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer")));
    }
  }

  window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([{
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this)
      }]);
    },
    setupShopifyXR(t) {
      t || (
        window.ShopifyXR ?
          (
            document.querySelectorAll('[id^="ModelJSON-"]').forEach((t => {
              window.ShopifyXR.addModels(JSON.parse(t.textContent));
              t.remove();
            })),
            window.ShopifyXR.setupXRElements()
          ) :
          document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR())
      );
    }
  };

  window.addEventListener("DOMContentLoaded", () => {
    window.ProductModel && window.ProductModel.loadShopifyXR();
  });

  const e = "[data-add-to-cart]",
        r = "[data-product-json]",
        o = "[data-product-form]",
        i = "#cart-bar",
        s = "[data-popup-open]",
        a = ".product__submit__add",
        n = "[data-form-wrapper]",
        d = "[data-product-variants]",
        c = "is-loading",
        l = "is-visible",
        h = "data-cart-bar-enabled",
        u = "data-add-to-cart-bar",
        p = "data-cart-bar-scroll",
        m = "data-cart-bar-product-notification",
        f = "data-sticky-enabled";

  customElements.get("product-component") ||
    customElements.define("product-component", class extends HTMLElement {
      constructor() {
        super();
        this.stickyEnabled = "true" === this.getAttribute(f);
        this.formWrapper = this.querySelector(n);
        this.cartBarEnabled = this.hasAttribute(h);
        this.cartBar = this.querySelector(i);
        this.setCartBarHeight = this.setCartBarHeight.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.toggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
        this.unlockTimer = 0;
      }

      connectedCallback() {
        const t = this.querySelector(r);
        if (t && !t.innerHTML || !t) return;

        const e = JSON.parse(t.innerHTML).handle;
        let i = {};
        e && (i = { handle: e });

        Shopify.Products.recordRecentlyViewed(i);
        Shopify.Products && Shopify.Products.recordRecentlyViewed && Shopify.Products.recordRecentlyViewed(i);

        this.form = this.querySelector(o);

        if (this.cartBarEnabled) {
          this.initCartBar();
          this.setCartBarHeight();
          document.addEventListener("theme:scroll", this.toggleCartBarOnScroll);
          document.addEventListener("theme:resize", this.setCartBarHeight);
        }
      }

      initCartBar() {
        this.cartBarBtns = this.cartBar.querySelectorAll(a);

        if (this.cartBarBtns.length > 0) {
          this.cartBarBtns.forEach((t => {
            t.addEventListener("click", (t => {
              t.preventDefault();

              if (t.currentTarget.hasAttribute(u)) {
                this.cartBarEnabled && (
                  t.currentTarget.classList.add(c),
                  t.currentTarget.setAttribute("disabled", "disabled")
                );
                this.form.querySelector(e).dispatchEvent(new Event("click", { bubbles: true }));
              } else if (t.currentTarget.hasAttribute(p)) {
                this.scrollToTop();
              } else if (t.currentTarget.hasAttribute(m)) {
                this.form.querySelector(s)?.dispatchEvent(new Event("click"));
              }
            }));

            t.hasAttribute(u) &&
              document.addEventListener("theme:product:add-error", this.scrollToTop);
          }));
        }

        this.setCartBarHeight();
      }

      scrollToTop() {
        const t = this.querySelector(d);
        const e = (window.theme.isMobile() ? t || this.form : this).getBoundingClientRect().top;
        window.theme.scrollTo(window.theme.isMobile() ? e - 10 : e);
      }

      // ✅ NEW: Show .cart-bar when product-component bottom < viewport
      toggleCartBarOnScroll() {
        if (this.cartBar) {
          const submitButtons = this.querySelector(".product__submit__buttons");
          if (!submitButtons) return;
      
          const top = submitButtons.getBoundingClientRect().top;
          const showCartBar = top < 0;
          this.cartBar.classList.toggle("is-visible", showCartBar);
        }
      }



      setCartBarHeight() {
        const t = this.cartBar.offsetHeight;
        document.documentElement.style.setProperty("--cart-bar-height", `${t}px`);
      }

      disconnectedCallback() {
        document.removeEventListener("theme:product:add-error", this.scrollToTop);

        if (this.cartBarEnabled) {
          document.removeEventListener("theme:scroll", this.toggleCartBarOnScroll);
          document.removeEventListener("theme:resize", this.setCartBarHeight);
        }
      }
    });

  customElements.get("product-model") || customElements.define("product-model", t);
}();


document.addEventListener('DOMContentLoaded', function (){
  // if(document.querySelector('.tootip-click')) document.querySelector('.tootip-click').addEventListener('click', function(e){
  //   e.preventDefault();
  //   document.querySelector('body').classList.add('open-tooltip-popup');
  // });
  // if(document.querySelectorAll('.tooltip-close,.tooltip-popup-overly')) document.querySelectorAll('.tooltip-close,.tooltip-popup-overly').forEach(function(tooltipClose){
  //   tooltipClose.addEventListener('click', function(e) {
  //     e.preventDefault();
  //     document.querySelector('body').classList.remove('open-tooltip-popup');
  //   });
  // });
// Open popup
  if (document.querySelector('.tootip-click')) {
    document.querySelector('.tootip-click').addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.remove('closing-tooltip-popup');
      document.body.classList.add('open-tooltip-popup');
    });
  }
  
  // Close popup with fade-out transition
  document.querySelectorAll('.tooltip-close, .tooltip-popup-overly').forEach(function(tooltipClose) {
    tooltipClose.addEventListener('click', function(e) {
      e.preventDefault();
  
      document.body.classList.remove('open-tooltip-popup');
      document.body.classList.add('closing-tooltip-popup');
  
      setTimeout(function() {
        document.body.classList.remove('closing-tooltip-popup');
      }, 300); // must match the CSS transition duration
    });
  });
  if(document.querySelectorAll('.product-toggle.pdp-toggle li')) document.querySelectorAll('.product-toggle.pdp-toggle li').forEach(button => {
    button.addEventListener('click', function (e){
      document.querySelectorAll('.product-toggle.pdp-toggle li').forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
    });
  });
  if(document.querySelectorAll('.product-toggle.tool-tip li')) document.querySelectorAll('.product-toggle.tool-tip li').forEach(button => {
    button.addEventListener('click', function (e){
      document.querySelectorAll('.product-toggle.tool-tip li').forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
    });
  });
  // if(document.querySelectorAll('.prod-rebuy-head li')) document.querySelectorAll('.prod-rebuy-head li').forEach(rebuy_head => {
  //   rebuy_head.addEventListener('click', function(e){
  //     e.preventDefault();
  //     document.querySelectorAll('.prod-rebuy-head li').forEach(btn => btn.classList.remove('active'));
  //     this.classList.add('active');
  //   });
  // });
  if(document.querySelectorAll('.prod-rebuy-head li')) document.querySelectorAll('.prod-rebuy-head a').forEach(tab => {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
  
      // Handle active class on <li>
      document.querySelectorAll('.prod-rebuy-head li').forEach(li => li.classList.remove('active'));
      this.closest('li').classList.add('active');
  
      // Get the href without '#'
      const hrefVal = this.getAttribute('href').replace('#', '');
  
      // Toggle active class on matching data-val elements
      document.querySelectorAll('.prod-style-buy, .prod-bundle').forEach(el => {
        if (el.getAttribute('data-val') === hrefVal || el.id === hrefVal) {
          el.classList.add('active');
        } else {
          el.classList.remove('active');
        }
      });
    });
  });

  if(document.querySelectorAll('.bundle-btn a')) document.querySelectorAll(".bundle-btn a").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      let li = this.closest("li");
      let container = li.querySelector(".bundle-prod");
      let content = li.querySelector(".rebuy-widget-container") || li.querySelector(".rebuy-bundle-builder__main");
      let cartBar = document.querySelector('.cart-bar');

      let isActive = li.classList.contains("active");

      if (isActive) {
        li.classList.remove("active");
        container.style.height = "0";
        if (content.classList.contains('rebuy-bundle-builder__main')) {
          container.style.overflow = "";
          if (cartBar) cartBar.style.display = "";
        }
      } else {
        document.querySelectorAll(".bundle-list li").forEach((item) => {
          item.classList.remove("active");
          let c = item.querySelector(".bundle-prod");
          c.style.height = "0";
        });
        li.classList.add("active");
        container.style.height = content.scrollHeight + 25 + "px";
          if (content.classList.contains('rebuy-bundle-builder__main')) {
            container.style.overflow = "visible";
          if (cartBar) cartBar.style.display = "none";
          }
      }
    });
  });
  if(document.querySelectorAll('.toggle-ellipsis__actions .read-less')) document.querySelectorAll(".toggle-ellipsis__actions .read-less").forEach((read_less) => {
    read_less.addEventListener("click", function (e) {
      e.preventDefault();
      read_less.closest('toggle-ellipsis').classList.remove('is-open');
      read_less.closest('toggle-ellipsis').style.setProperty('--height', '140px');
    });
  });
  var productSlider = new Swiper('.product__slides.swiper', {
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1, 
    direction: 'horizontal',
    simulateTouch: true,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 0.5,
      thresholdDelta: 10,
      thresholdTime: 500,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    resizeObserver: true,
  });
  var productThumbs = new Swiper('.swiper.product__thumbs', {
    slidesPerView: "auto",
    centeredSlides: false,
    slideToClickedSlide: true,
  });
  function updateThumbsActiveClass() {
    const thumbsSlides = productThumbs.slides;
    thumbsSlides.forEach(slide => slide.classList.remove('swiper-slide-thumb-active'));
    const activeIndex = productSlider.realIndex;
    const activeThumb = thumbsSlides[activeIndex];
    if (activeThumb) activeThumb.classList.add('swiper-slide-thumb-active');
  }
  updateThumbsActiveClass();
  productSlider.on('slideChange', () => {
    updateThumbsActiveClass();
    productThumbs.slideTo(productSlider.activeIndex);
  });
  productThumbs.on('click', () => {
    productSlider.slideTo(productThumbs.clickedIndex);
  });
  var prod_color = new Swiper('.prod-color-slider', {
    slidesPerView: 7,
    slidesPerGroup: 6,
    simulateTouch: true,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 0.5,
      thresholdDelta: 10,
      thresholdTime: 500,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
    450: {
      slidesPerView: 10.7,
      slidesPerGroup: 9,
      spaceBetween: 8,
    },
    575: {
      slidesPerView: 15,
      slidesPerGroup: 13,
      spaceBetween: 8,
    },
    767: {
      slidesPerView: 17,
      slidesPerGroup: 13,
      spaceBetween: 8,
    },
    990: {
      slidesPerView: 10.7,
      slidesPerGroup: 9,
      spaceBetween: 8,
    }
  }
    
  });
  if(document.querySelectorAll('.prod-color-type li')) document.querySelectorAll('.prod-color-type li').forEach(button => {
    button.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      document.querySelectorAll('.prod-color-type li').forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      let filter = this.textContent.trim();
      document.querySelectorAll('.prod-color-swatch li').forEach(swatch => {
        let swatchFilter = swatch.getAttribute('data-value');
        if(filter === 'All Colors'){
          swatch.style.display = '';
        }else if (swatchFilter && swatchFilter.includes(filter)){
          swatch.style.display = '';
        }else{
          swatch.style.display = 'none';
        }
      });
      setTimeout(() => {
        prod_color.update();
      }, 50);
    });
  });

  const eu_countries = "NL,BE,DE,FR,LU,RO,HU,SK,CZ,AT,DK,IT,PL,IE,ES,LV,LT,PT,SI,FI,GR,TR,SE,BG,HR,CY,EE,MT".split(',');

  // Function to handle variant availability logic
  function handleVariantAvailability(widgetId, widget, isEU) {
    console.log(`Processing bundle with data-rebuy-id: ${widgetId}`);

    widget.data.products.forEach((product, productIndex) => {
      console.log(`    Product ${productIndex}:`, product);
      console.log(`  Product ${productIndex}: ${product.title || product.id}`);
      
      // Check if this is a rebuy-bundle-builder widget
      const bundleProd = document.querySelector(`.bundle-prod[data-rebuy-id="${widgetId}"]`);
      const isBundleBuilder = bundleProd && bundleProd.querySelector('.rebuy-bundle-builder');
      
      // Parse product-level metafields if this is a bundle builder
      if (product.published_at === null) {
        setTimeout(() => {
          const rebuyButton = bundleProd.querySelector('.rebuy-bundle-builder__group-container-inner .rebuy-button');
          if (rebuyButton) {
            // Hide the original button
            rebuyButton.style.display = 'none';
            
            // Create new "Sold Out" button if it doesn't exist
            let soldOutButton = bundleProd.querySelector('.rebuy-button.sold-out');
            if (!soldOutButton) {
              soldOutButton = document.createElement('button');
              soldOutButton.setAttribute('aria-label', 'Add all selected products to cart');
              soldOutButton.className = 'rebuy-button sold-out';
              soldOutButton.disabled = true;
              soldOutButton.innerHTML = '<span>Sold Out</span>';
              
              // Insert after the original button
              rebuyButton.parentNode.insertBefore(soldOutButton, rebuyButton.nextSibling);
            }
          }
        }, 100);
        return;
      }
      let productAvailabilityMap = {};
      if (isBundleBuilder) {
        const availabilityField = isEU ? 
          product?.metafields?.custom?.eu_availability : 
          product?.metafields?.custom?.uk_availability;
          
        if (availabilityField) {
          // Parse the availability string format: [variantId|availability],[variantId|availability],...
          const pairs = availabilityField.split('],[');
          pairs.forEach(pair => {
            const cleanPair = pair.replace(/^\[|\]$/g, ''); // Remove leading [ or trailing ]
            const [variantId, availability] = cleanPair.split('|');
            if (variantId && availability !== undefined) {
              productAvailabilityMap[variantId] = availability === 'true';
            }
          });
          console.log(`    Product availability map:`, productAvailabilityMap);
        }
      }
      
      product.variants.forEach((variant, variantIndex) => {
        console.log(`    Variant ${variantIndex}:`, variant);
        let available = true;
        let reason = '';
        let variant_available;
        // console.log('isPublished:', product.published_at);
        if (isBundleBuilder && Object.keys(productAvailabilityMap).length > 0) {
          // Use product-level metafield data for bundle builders
          const variantAvailability = productAvailabilityMap[variant.id];
          if (variantAvailability !== undefined) {
            available = variantAvailability;
            reason = isEU ? 'eu_availability_product_level' : 'uk_availability_product_level';
          } else {
            // Skip if no data found for this variant in product metafield
            return;
          }
          
        if (event.detail.product) {
          console.log('Added product variant:', event.detail.product.selected_variant_id);
          
          // Check if this variant matches the selected variant from the event
          if (variant.id == event.detail.product.selected_variant_id) {
            variant_available = available ? true : false;
            console.log(`Variant ${variant.id} matches selected variant. Available: ${variant_available}`);
            
            // Handle rebuy button for bundle builder when variant_available is false
            if (variant_available === false) {
              setTimeout(() => {
                const rebuyButton = bundleProd.querySelector('.rebuy-bundle-builder__group-container-inner .rebuy-button');
                if (rebuyButton) {
                  // Hide the original button
                  rebuyButton.style.display = 'none';
                  
                  // Create new "Sold Out" button if it doesn't exist
                  let soldOutButton = bundleProd.querySelector('.rebuy-button.sold-out');
                  if (!soldOutButton) {
                    soldOutButton = document.createElement('button');
                    soldOutButton.setAttribute('aria-label', 'Add all selected products to cart');
                    soldOutButton.className = 'rebuy-button sold-out';
                    soldOutButton.disabled = true;
                    soldOutButton.innerHTML = '<span>Sold Out</span>';
                    
                    // Insert after the original button
                    rebuyButton.parentNode.insertBefore(soldOutButton, rebuyButton.nextSibling);
                  }
                }
              }, 100);
            }
          }
        }
          // console.log(`    Variant ${variantIndex}: ${variant.title || variant.id}, availability from product metafield: ${available}`);
        } else {
          if (variant?.inventory_policy === 'continue') {
            // Variant set to continue selling when out of stock – treat as available regardless of regional metafields
            available = true;
            reason = 'inventory_policy_continue';
          } else if (isEU) {
              const euAvailable = variant?.metafields?.custom?.eu_available;
              console.log(`    Variant ${variantIndex}: ${variant.title || variant.id}, eu_available: ${euAvailable}`);
              if (euAvailable === undefined) {
                return;
              }
              available = euAvailable === 'true';
              reason = 'eu_available';
          } else {
              const ukAvailable = variant?.metafields?.custom?.uk_available;
              if (ukAvailable === undefined) {
                return;
              }
              available = ukAvailable === 'true';
              reason = 'uk_available';
          }
        }


        if (!available) {
          // Skip select option disabling for bundle builders, only handle regular bundles
          const bundleProd = document.querySelector(`.bundle-prod[data-rebuy-id="${widgetId}"]`);
          console.log(`      Bundle product for widget id ${widgetId}:`, bundleProd);
           const selects = bundleProd.querySelectorAll('.rebuy-select');
           const select = selects[productIndex] || selects[0] || null;
          if (select) {
            // Find the option with value equal to the variant id
            const option = select.querySelector(`option[value="${variant.id}"]`);
            console.log(`      Option for variant id ${variant.id}:`, option);
            if (option) {
              console.log(`      Disabling option for variant id ${variant.id} (${variant.title})`);
              option.disabled = true; // disables the option
              console.log(`      Disabling option`, option);

              // If this option is currently selected, select the next enabled option
              if (option.selected) {
                console.log(`      Option for variant id ${variant.id} was selected. Selecting next enabled option.`);
                // Try to select the next enabled option, or previous if at end
                let nextEnabled = option.nextElementSibling;
                while (nextEnabled && nextEnabled.disabled) {
                  nextEnabled = nextEnabled.nextElementSibling;
                }
                if (!nextEnabled) {
                  // Try previous siblings if no next enabled found
                  nextEnabled = option.previousElementSibling;
                  while (nextEnabled && nextEnabled.disabled) {
                    nextEnabled = nextEnabled.previousElementSibling;
                  }
                }
                if (nextEnabled) {
                  nextEnabled.selected = true;
                  // Optionally, trigger change event if needed
                  option.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
                  // console.log(`      Selected variant id ${nextEnabled.value}`);
                } else {
                  console.warn('      No enabled options available to select.');
                }
              }
            } else {
              console.warn(`      Could not find option for variant id: ${variant.id}`);
            }
          } else {
            console.warn(`      Could not find .rebuy-select for product ${productIndex}`);
          }

          if (bundleProd) {
            // If there are selects, check if all options are disabled
            if (selects.length > 1) {
              selects.forEach(select => {
                const allDisabled = Array.from(select.options).every(opt => opt.disabled);
                if (allDisabled) {
                  const rebuyButton = bundleProd.querySelector('.rebuy-button');
                  if (rebuyButton) {
                    rebuyButton.disabled = true;
                    rebuyButton.classList.add('is-disabled');
                    rebuyButton.textContent = 'Sold Out';
                  }
                  const optionsContainer = select.closest('.rebuy-product-options');
                  if (optionsContainer) {
                    const soldOutMsg = document.createElement('span');
                    soldOutMsg.className = 'rebuy-select-soldout';
                    soldOutMsg.textContent = 'Sold Out';
                    optionsContainer.parentNode.replaceChild(soldOutMsg, optionsContainer);
                  } else {
                    const soldOutMsg = document.createElement('span');
                    soldOutMsg.className = 'rebuy-select-soldout';
                    soldOutMsg.textContent = 'Sold Out';
                    select.parentNode.replaceChild(soldOutMsg, select);
                  }
                }
              });
            }
            if (selects.length < 1) {
              // No select present (single variant case)
              if (!available) {
                const rebuyButton = bundleProd.querySelector('.rebuy-button');
                if (rebuyButton) {
                  rebuyButton.disabled = true;
                  rebuyButton.classList.add('is-disabled');
                  rebuyButton.textContent = 'Sold Out';
                }
              }
            }
            // Handle single variant products (when product has only 1 variant at index 0)
            if (product.variants.length === 1 && variantIndex === 0 && !available) {
              const rebuyButton = bundleProd.querySelector('.rebuy-button');
              if (rebuyButton) {
                rebuyButton.disabled = true;
                rebuyButton.classList.add('is-disabled');
                rebuyButton.textContent = 'Sold Out';
              }
            }
          }
        }
      });
    });
  }

  document.addEventListener('rebuy.ready', function(event) {
      let widgetId = event.detail.widget.id;
      const widget = window.Rebuy.widgets.find((w) => w.id === widgetId );
      const visitorCountry = window.Shopify.country;
      const isEU = visitorCountry && eu_countries.includes(visitorCountry);

    handleVariantAvailability(widgetId, widget, isEU);

    // Check if this is a bundle builder and add click event listeners to all rebuy buttons
    // const bundleProd = document.querySelector(`.bundle-prod[data-rebuy-id="${widgetId}"]`);
    // const isBundleBuilder = bundleProd && bundleProd.querySelector('.rebuy-bundle-builder');
    // if (isBundleBuilder) {
    //   setTimeout(() => {
    //     // Re-run availability logic after a short delay to allow for DOM updates
    //     const rebuyButtons = document.querySelectorAll('.rebuy-bundle-builder__step-product .rebuy-bundle-builder__item-quantity-widget-button');
    //     console.log(rebuyButtons);
    //     rebuyButtons.forEach(rebuyButton => {
    //       if (rebuyButton) {
    //         rebuyButton.addEventListener('click', function() {
    //           // Re-run availability logic after a short delay to allow for DOM updates
    //               let widgetId = event.detail.widget.id;
    //               const bundleProd = document.querySelector(`.bundle-prod[data-rebuy-id="${widgetId}"]`);
    //               if (bundleProd) {
    //                 setTimeout(() => {
    //                   const rebuyButton = bundleProd.querySelector('.rebuy-bundle-builder__group-container-inner .rebuy-button');
    //                   const soldOutButton = bundleProd.querySelector('.rebuy-button.sold-out');
                      
    //                   if (rebuyButton) {
    //                     // Show the original button
    //                     rebuyButton.style.display = '';
    //                   }
                      
    //                   if (soldOutButton) {
    //                     // Remove the sold out button
    //                     soldOutButton.remove();
    //                   }
    //                 }, 100);
    //               }
    //           // setTimeout(() => {
    //           //   handleVariantAvailability(widgetId, widget, isEU);
    //           // }, 100);
    //         });
    //       }
    //     });
    //   }, 1000);
    // }

  document.addEventListener('rebuy.addProductToBundle', function(event){   
    handleVariantAvailability(widgetId, widget, isEU);

        const bundleProd = document.querySelector(`.bundle-prod[data-rebuy-id="${widgetId}"]`);
    const isBundleBuilder = bundleProd && bundleProd.querySelector('.rebuy-bundle-builder');
    if (isBundleBuilder) {
      setTimeout(() => {
        const rebuyButtons = document.querySelectorAll('.rebuy-bundle-builder__step-product .rebuy-bundle-builder__item-quantity-widget-button');
        rebuyButtons.forEach(rebuyButton => {
          if (rebuyButton) {
            rebuyButton.addEventListener('click', function() {
                  let widgetId = event.detail.widget.id;
                  const bundleProd = document.querySelector(`.bundle-prod[data-rebuy-id="${widgetId}"]`);
                  if (bundleProd) {
                    setTimeout(() => {
                      const rebuyButton = bundleProd.querySelector('.rebuy-bundle-builder__group-container-inner .rebuy-button');
                      const soldOutButton = bundleProd.querySelector('.rebuy-button.sold-out');
                      
                      if (rebuyButton) {
                        rebuyButton.style.display = '';
                      }
                      
                      if (soldOutButton) {
                        soldOutButton.remove();
                      }
                    }, 100);
                  }
              // setTimeout(() => {
              //   handleVariantAvailability(widgetId, widget, isEU);
              // }, 100);
            });
          }
        });
      }, 1000);
    }
  });
  document.addEventListener('rebuy.removeProductFromBundle', function(event){
        let widgetId = event.detail.widget.id;
    const bundleProd = document.querySelector(`.bundle-prod[data-rebuy-id="${widgetId}"]`);
    if (bundleProd) {
      setTimeout(() => {
        const rebuyButton = bundleProd.querySelector('.rebuy-bundle-builder__group-container-inner .rebuy-button');
        const soldOutButton = bundleProd.querySelector('.rebuy-button.sold-out');
        
        if (rebuyButton) {
          rebuyButton.style.display = '';
        }
        
        if (soldOutButton) {
          soldOutButton.remove();
        }
      }, 100);
    }
  });
    

    let all_id = event.detail.widget.id
    document.querySelectorAll('.bundle-prod').forEach(bundle => {
      let id = bundle.getAttribute('data-rebuy-id');
      if(id == all_id){
        let price = bundle.querySelector('.rebuy-widget').getAttribute('data-bundle-price');
        let compare_price = bundle.querySelector('.rebuy-widget').getAttribute('data-bundle-compare-price');
        let save = bundle.querySelector('.rebuy-widget').getAttribute('data-bundle-save-price');
        if(price || compare_price || save){
          if(document.querySelector('.product_bundle.bundle-prod')){
            if(price) bundle.closest('.product__content').querySelector('.product__price--sale').textContent = price;
            if(compare_price) bundle.closest('.product__content').querySelector('.product__price--strike').textContent = compare_price;
            if(save && compare_price){
              let save_final = parseFloat(save.replace(/[^0-9.]/g, ""));
              let compare_final = parseFloat(compare_price.replace(/[^0-9.]/g, ""));
              if(compare_final > 0){
                let percent = Math.round((save_final / compare_final) * 100);
                let percentText = `${percent}%`;
                bundle.closest('.product__content').querySelector('.product__price__wrap .product__price--off').classList.remove('hidden');
                bundle.closest('.product__content').querySelector('.product__price__wrap .product__final-sale-wrap').classList.remove('hidden');
                bundle.closest('.product__content').querySelector('.product__price__wrap .product__price--off span').textContent = percentText;
              }
            }
          }else{
            if(price) bundle.closest('li').querySelector('.bundle-price .original_price').textContent = price;
            if(compare_price) bundle.closest('li').querySelector('.bundle-price .compare_price').textContent = compare_price;
            if(save) bundle.closest('li').querySelector('.bundle-savings span').textContent = 'Save ' + save;
          }
        }
      }
    });    
  });
});